import React from 'react';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

export const ClientForm = ({ dto, t }) => {

    return (
        <Box sx={{ mb: 2 }}>
            <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField
                        fullWidth
                        required
                        disabled
                        size="small"
                        label={t('commonFields.nit')}
                        name="id_company_receiver"
                        value={dto.id_company_receiver || ''}
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 4 }}>
                    <TextField
                        fullWidth
                        required
                        disabled
                        size="small"
                        label={t('commonFields.businessName')}
                        name="company_receiver_name"
                        value={dto.company_receiver_name || ''}
                    />
                </Grid>
            </Grid>
        </Box>
    );
};
